import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGOUT_USER
} from 'Constants/actionTypes';

export const loginUser = (user, history,form) => ({
  type: LOGIN_USER,
  payload: { user, history,form }
});
export const loginUserSuccess = (user) => ({
  type: LOGIN_USER_SUCCESS,
  payload: user
});


export const logoutUser = (history) => ({
  type: LOGOUT_USER,
  payload : {history}
});